import { Product, ProductVariant } from 'common/api/e-comm/models/Product';
import { monetize, conjunct, monetizeWithDecimal } from 'common/utils/strings';

const productToPriceVariantsMap = (product: Product) =>
    product.variants.reduce<Map<number, ProductVariant[]>>((total, next) => {
        const variants = total.get(next.price) || [];
        variants.push(next);
        total.set(next.price, variants);
        return total;
    }, new Map());

const emptyVariants = {
    text: '',
    variants: [],
};

export const useUnavailableProductVariants = (product?: Product) => {
    if (!product) {
        return emptyVariants;
    }

    const unavailableVariants = Array.from(productToPriceVariantsMap(product))
        .filter(([, variants]) => variants.every(({ isAvailable }) => !isAvailable))
        .map(([price]) => price);

    if (!unavailableVariants.length) {
        return emptyVariants;
    }

    const variantsMonetized = unavailableVariants.map((n) => monetizeWithDecimal(n));

    if (unavailableVariants.length === product.variants.length) {
        return {
            text: 'This card is temporarily unavailable.',
            variants: variantsMonetized,
        };
    }

    return {
        text: `This card is temporarily unavailable in amounts of ${conjunct(
            unavailableVariants.map((n) => monetize(n))
        )}`,
        variants: variantsMonetized,
    };
};

export default useUnavailableProductVariants;
